import { useMutation, useQueryClient } from "react-query";
import authAPI from "../authAPI";

export const useToggleActiveGroup = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ id, active }) => authAPI.updateGroup(id, { active }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["organizations"]);
        queryClient.invalidateQueries(["user", "me", "group-memberships"]);
      },
    }
  );
};
